import * as z from "zod";

import {
  dateSchema,
  referenceObject,
  requiredString,
} from "components/form/utils";

import { bucketJobConfigSchema } from "@/modules/work/jobs/config/bucket/schema";
import { dedicatedJobConfigSchema } from "@/modules/work/jobs/config/dedicated/schema";
import { fixedJobConfigSchema } from "@/modules/work/jobs/config/fixed/schema";
import { hourlyJobConfigSchema } from "@/modules/work/jobs/config/hourly/schema";
import { recurringJobConfigSchema } from "@/modules/work/jobs/config/recurring/schema";

// const referenceObject = z.object({
//   id: z.string().min(1, "ID is required"),
// });

export const baseJobSchema = z.object({
  name: requiredString(),
  type: z.enum(["fixed", "hourly", "dedicated", "recurring", "bucket", "free"], {
    required_error: "Job type is required",
  }),
  coordinator: referenceObject(),
  description: z.optional(z.string().nullable()),
  margin_calculator_link: z.optional(z.string().nullable()),
  start_date: dateSchema,
  end_date: dateSchema,
  status: z.string().default("draft"),
  project: z.string().min(1, "project is required"),
  contract: z.string().optional().nullable(),
  disable_job_logging: z.boolean().default(false).optional(),
  tags: z.optional(z.any()).nullable(),
});

export const jobSchema = baseJobSchema;

// === JOB SCHEMAS WITH CONFIG ===
export const fixedJobSchema = baseJobSchema.extend({
  fixed_job_config: fixedJobConfigSchema,
});

export const hourlyJobSchema = baseJobSchema.extend({
  hourly_job_config: hourlyJobConfigSchema,
});

export const dedicatedJobSchema = baseJobSchema.extend({
  dedicated_job_config: dedicatedJobConfigSchema,
});

export const bucketJobSchema = baseJobSchema.extend({
  bucket_job_config: bucketJobConfigSchema,
});

// export const recurringJobSchema = baseJobSchema.extend({
//   recurring_job_config: recurringJobConfigSchema,
// });

// Default export for basic job schema
export default baseJobSchema;
